<template>
  <div>
    <!-- Content Row -->
    <b-row align="left">
      <b-col md="8" class="mt-2">
        <p class="mb-1 font-weight-bold">
          <font class="h4 text-primary">Transaction Log</font>
          &nbsp;&nbsp;&nbsp;
          <font class="h5 ml-5 text-warning border rounded p-1">{{
            tanggal
          }}</font>
        </p>
      </b-col>
      <b-col class="text-right">
        <b-row>
          <b-col>
            <b-button
              @click="filterShow = !filterShow"
              class="bg-white text-primary border-secondary"
            >
              <img src="@/assets/filter.svg" alt /> Filter Data
            </b-button>
          </b-col>
          <b-col>
            <download-csv
              class="d-none"
              :data="CSV"
              :name="name_export"
              ref="DownloadCSV"
            ></download-csv>
            <b-button
              class="btn btn-primary"
              :disabled="loadingCSV"
              @click="downloadCSV()"
            >
              <b-spinner label="Spinning" v-show="loadingCSV" small></b-spinner
              >Export to CSV
            </b-button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <br />
    <div class="text-left">
      <b-row class="mt-4">
        <b-col md="4" class="my-1">
          <b-form-group class="mb-0">
            <b-input-group>
              <b-form-input
                v-model="filter"
                placeholder="Search"
              ></b-form-input>
              <b-input-group-append>
                <b-button
                  variant="primary"
                  :disabled="!filter"
                  @click="filter = ''"
                  >Clear</b-button
                >
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="2" class="my-1" align="right">
          <b-form-group label-cols-sm="6" label="Show" class="mb-0">
            <b-form-select
              v-model="perPage"
              :options="pageOptions"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col md="3" class="my-1"></b-col>
      </b-row>
      <b-row>
        <br />
      </b-row>
      <section v-if="errored">
        <p>
          We're sorry, we're not able to retrieve this information at the
          moment, please try back later
        </p>
      </section>
      <!-- Main table element -->
      <b-table
        v-else
        responsive
        show-empty
        ref="pxContent"
        hover
        :items="getInfo"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        @filtered="onFiltered"
        head-variant="light"
        class="bg-white"
        filter-debounce="500"
      >
        <div slot="table-busy" class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
        <template v-slot:cell(payment_method)="{ value, item }">
          <div v-if="item.issuer">
            <p class="text-uppercase">{{ value }} - {{ item.issuer }}</p>
          </div>
          <div v-else>
            <p>
              {{ value }}
            </p>
          </div>
        </template>
        <template v-slot:cell(status)="row">
          <div class="text-capitalize">
            <p
              class="text-warning"
              v-if="row.value == 'pending' || row.value == 'refunded'"
            >
              {{ row.value }}
            </p>
            <p
              class="text-danger"
              v-if="row.value == 'refund failed' || row.value == 'cancel'"
            >
              {{ row.value }}
            </p>
            <p
              class="text-success"
              v-else-if="row.value == 'created' || row.value == 'paid'"
            >
              {{ row.value }}
            </p>
          </div>
        </template>

        <template v-slot:cell(action)="{ value, item }">
          <!-- <router-link :to="{}" class="text-dark">
            <i class="fas fa-file-download mr-2"></i>
          </router-link>-->
          <router-link
            :to="{ name: 'detailTransactionLog', params: { id: item.id } }"
            class="text-primary"
            v-if="item.payment_method"
          >
            <i class="fas fa-eye"></i>
          </router-link>
        </template>
      </b-table>

      <b-row class="mx-auto">
        <b-col md="4" class="mx-auto px-0">Total entries {{ totalRows }}</b-col>
        <b-col md="4" class="mx-auto"></b-col>
        <b-col md="4" align="right" class="px-0">
          <b-pagination
            align="right"
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            class="my-0"
          ></b-pagination>
        </b-col>
      </b-row>
    </div>
    <b-modal
      v-model="filterShow"
      id="modal-prevent-closing"
      hide-header
      hide-footer
      no-close-on-esc
      no-close-on-backdrop
      size="md"
    >
      <!-- <h4>Kirim ke Email</h4> -->
      <br />
      <b-row>
        <b-col md="12">
          <b-row>
            <b-col md="6">
              <b-form-group
                id="fieldset-1"
                label="Ref. Number"
                class="font-weight-bold"
                label-for="input-1"
              >
                <input
                  placeholder="Ref. Number"
                  v-model="ref_number"
                  name="ref_number"
                  data-vv-as="Ref. Number"
                  class="form-control"
                />

                <p
                  class="text-danger"
                  style="width: 100%; margin-top: 0.25rem; font-size: 80%"
                >
                  {{ veeErrors.first("ref_number") }}
                </p>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                id="fieldset-1"
                label="AWB Number"
                class="font-weight-bold"
                label-for="input-1"
              >
                <input
                  placeholder="AWB Number"
                  v-model="awb_number"
                  name="awb_number"
                  data-vv-as="AWB Number"
                  class="form-control"
                />

                <p
                  class="text-danger"
                  style="width: 100%; margin-top: 0.25rem; font-size: 80%"
                >
                  {{ veeErrors.first("awb_number") }}
                </p>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                id="fieldset-1"
                label="Amount (min)"
                class="font-weight-bold"
                label-for="input-1"
              >
                <input
                  placeholder="Amount (min)"
                  v-model="amount_min"
                  type="number"
                  v-validate="'numeric'"
                  name="amount_min"
                  data-vv-as="Amount (min)"
                  class="form-control"
                />

                <p
                  class="text-danger"
                  style="width: 100%; margin-top: 0.25rem; font-size: 80%"
                >
                  {{ veeErrors.first("amount_min") }}
                </p>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                id="fieldset-1"
                label="Amount (max)"
                class="font-weight-bold"
                label-for="input-1"
              >
                <input
                  placeholder="Amount (max)"
                  v-model="amount_max"
                  v-validate="'numeric'"
                  name="amount_max"
                  type="number"
                  data-vv-as="Amount (max)"
                  class="form-control"
                />

                <p
                  class="text-danger"
                  style="width: 100%; margin-top: 0.25rem; font-size: 80%"
                >
                  {{ veeErrors.first("amount_max") }}
                </p>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                id="fieldset-1"
                label="Transaction Status"
                class="font-weight-bold"
                label-for="input-1"
              >
                <b-form-select
                  v-model="trensaction_status"
                  name="trensaction_status"
                  data-vv-as="Transaction Status"
                  class="mb-3"
                >
                  <template v-slot:first>
                    <option value disabled>-- Transaction Status --</option>
                  </template>
                  <option value="created">Created</option>
                  <option value="cancel">Cancel</option>
                  <option value="paid">Paid</option>
                  <option value="pending">Pending</option>
                  <option value="refunded">Refunded</option>
                  <option value="refund failed">Refund Failed</option>
                </b-form-select>

                <p
                  class="text-danger"
                  style="width: 100%; margin-top: 0.25rem; font-size: 80%"
                >
                  {{ veeErrors.first("trensaction_status") }}
                </p>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                id="fieldset-1"
                label="Payment Method"
                class="font-weight-bold"
                label-for="input-1"
              >
                <b-form-select
                  v-model="payment_method"
                  name="payment_method"
                  data-vv-as="Payment Method"
                  class="mb-3"
                  v-for="group in payment_method_array"
                  :key="group"
                >
                  <template v-slot:first>
                    <option value disabled>-- Payment Method --</option>
                  </template>
                  <option
                    v-for="data in group.data"
                    :key="data"
                    :value="data.method_name"
                  >
                    {{ data.display_name }}
                  </option>
                </b-form-select>

                <p
                  class="text-danger"
                  style="width: 100%; margin-top: 0.25rem; font-size: 80%"
                >
                  {{ veeErrors.first("payment_method") }}
                </p>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                id="fieldset-1"
                label="Locker Order Type"
                class="font-weight-bold"
                label-for="input-1"
              >
                <b-form-select
                  v-model="locker_order_type"
                  name="locker_order_type"
                  data-vv-as="Locker Order Type"
                  class="mb-3"
                >
                  <template v-slot:first>
                    <option value disabled>-- Locker Order Type --</option>
                  </template>
                  <option value="Rental">Rental</option>
                  <option value="Drop Off">Drop Off</option>
                </b-form-select>

                <p
                  class="text-danger"
                  style="width: 100%; margin-top: 0.25rem; font-size: 80%"
                >
                  {{ veeErrors.first("locker_order_type") }}
                </p>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="12">
          <b-row>
            <b-col md="6">
              <b-form-group
                id="fieldset-1"
                label="Created Date (from)"
                class="font-weight-bold"
                label-for="input-1"
              >
                <b-row class="m-0 pr-4">
                  <b-col
                    class="pr-0 pt-1 form-control img-calender-select border-right-0"
                    md="2"
                  >
                    <img
                      src="@/assets/ic-calendar-copy-30.svg"
                      width="25px"
                      alt
                      class
                    />
                  </b-col>
                  <b-col class="px-0">
                    <datepicker
                      input-class="form-control text-dark pl-0 bg-white calender-select border-left-0 border-right-0"
                      placeholder="Select Date"
                      v-model="created_date_from"
                      :format="customFormatter"
                      :disabledDates="element2"
                    ></datepicker>
                  </b-col>
                  <b-col align="left" md="1" class="px-0">
                    <b-col
                      align="left"
                      class="pt-1 px-4 form-control del-calender-select border-left-0"
                      md="2"
                    >
                      <b-row align="left" class="pt-1">
                        <b-col>
                          <b-link
                            @click="resetCreatedDateFrom"
                            style="text-decoration: none"
                          >
                            <i class="text-danger fas fa-times"></i>
                          </b-link>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-col>
                </b-row>
                <br />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                id="fieldset-1"
                label="Created Date (to)"
                class="font-weight-bold"
                label-for="input-1"
              >
                <b-row class="m-0 pr-4">
                  <b-col
                    class="pr-0 pt-1 form-control img-calender-select border-right-0"
                    md="2"
                  >
                    <img
                      src="@/assets/ic-calendar-copy-30.svg"
                      width="25px"
                      alt
                      class
                    />
                  </b-col>
                  <b-col class="px-0">
                    <datepicker
                      input-class="form-control text-dark pl-0 bg-white calender-select border-left-0 border-right-0"
                      placeholder="Select Date"
                      v-model="created_date_to"
                      :format="customFormatter"
                      :disabledDates="element"
                    ></datepicker>
                  </b-col>
                  <b-col align="left" md="1" class="px-0">
                    <b-col
                      align="left"
                      class="pt-1 px-4 form-control del-calender-select border-left-0"
                      md="2"
                    >
                      <b-row align="left" class="pt-1">
                        <b-col>
                          <b-link
                            @click="resetCreatedDateTo"
                            style="text-decoration: none"
                          >
                            <i class="text-danger fas fa-times"></i>
                          </b-link>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-col>
                </b-row>
                <br />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                id="fieldset-1"
                label="Paid Date (from)"
                class="font-weight-bold"
                label-for="input-1"
              >
                <b-row class="m-0 pr-4">
                  <b-col
                    class="pr-0 pt-1 form-control img-calender-select border-right-0"
                    md="2"
                  >
                    <img
                      src="@/assets/ic-calendar-copy-30.svg"
                      width="25px"
                      alt
                      class
                    />
                  </b-col>
                  <b-col class="px-0">
                    <datepicker
                      input-class="form-control text-dark pl-0 bg-white calender-select border-left-0 border-right-0"
                      placeholder="Select Date"
                      v-model="paid_date_from"
                      :format="customFormatter"
                      :disabledDates="element4"
                    ></datepicker>
                  </b-col>
                  <b-col align="left" md="1" class="px-0">
                    <b-col
                      align="left"
                      class="pt-1 px-4 form-control del-calender-select border-left-0"
                      md="2"
                    >
                      <b-row align="left" class="pt-1">
                        <b-col>
                          <b-link
                            @click="resetPaidDateFrom"
                            style="text-decoration: none"
                          >
                            <i class="text-danger fas fa-times"></i>
                          </b-link>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-col>
                </b-row>
                <br />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                id="fieldset-1"
                label="Paid Date (to)"
                class="font-weight-bold"
                label-for="input-1"
              >
                <b-row class="m-0 pr-4">
                  <b-col
                    class="pr-0 pt-1 form-control img-calender-select border-right-0"
                    md="2"
                  >
                    <img
                      src="@/assets/ic-calendar-copy-30.svg"
                      width="25px"
                      alt
                      class
                    />
                  </b-col>
                  <b-col class="px-0">
                    <datepicker
                      input-class="form-control text-dark pl-0 bg-white calender-select border-left-0 border-right-0"
                      placeholder="Select Date"
                      v-model="paid_date_to"
                      :format="customFormatter"
                      :disabledDates="element3"
                    ></datepicker>
                  </b-col>
                  <b-col align="left" md="1" class="px-0">
                    <b-col
                      align="left"
                      class="pt-1 px-4 form-control del-calender-select border-left-0"
                      md="2"
                    >
                      <b-row align="left" class="pt-1">
                        <b-col>
                          <b-link
                            @click="resetPaidDateTo"
                            style="text-decoration: none"
                          >
                            <i class="text-danger fas fa-times"></i>
                          </b-link>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-col>
                </b-row>
                <br />
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <br />
      <b-row>
        <b-col offset-md="8" md="2">
          <b-button
            variant="light"
            @click="ResetFilterData()"
            class="text-primary border-secondary"
            block
            size="lg"
            >Reset</b-button
          >
        </b-col>
        <b-col md="2" align-self="right" class="text-right">
          <b-button variant="primary" @click="FilterData()" block size="lg"
            >Apply</b-button
          >
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
export default {
  components: {
    Datepicker,
  },
  data() {
    return {
      ref_number: "",
      awb_number: "",
      amount_min: "",
      amount_max: "",
      trensaction_status: "",
      locker_order_type: "",
      payment_method: "",
      created_date_from: new Date(Date.now()-8640000),
      created_date_to: new Date(Date.now()),
      paid_date_from: "",
      paid_date_to: "",
      filterShow: false,
      loading: false,
      errored: false,
      tanggal: new Date().toJSON().slice(0, 10).replace(/-/g, "/"),
      fields: [
        {
          key: "payment_method",
          label: "P. Method",
          sortable: true,
          class: "text-center",
        },
        {
          key: "created_at",
          label: "Created Date",
          sortable: true,
          class: "text-center",
        },
        {
          key: "paid_at",
          label: "Paid Date",
          sortable: true,
          class: "text-center",
        },
        {
          key: "transaction_code",
          label: "Ref. Number",
          sortable: true,
          class: "text-center",
        },
        {
          key: "acquirement_id",
          label: "Acquirement ID",
          sortable: true,
          class: "text-center",
        },
        {
          key: "amount",
          label: "Amount",
          sortable: true,
          class: "text-center",
        },
        {
          key: "status",
          label: "Status",
          sortable: true,
          class: "text-center",
        },
        {
          key: "awb",
          label: "AWB",
          sortable: true,
          class: "text-center",
        },
        {
          key: "locker_order_type",
          label: "Locker Order",
          sortable: true,
          class: "text-center",
        },
        { key: "action", label: "Action", class: "text-center" },
      ],
      candidate: [],
      job_place: [],
      date_from: new Date(new Date().setDate(new Date().getDate() - 30)),
      date_to: new Date(Date.now()),
      name_export:
        "TransactionLog" +
        moment(new Date(Date.now())).format("YYYY-MM-DD") +
        ".csv",
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: "",
      customerShow: false,
      loadingCSV: false,
      CSV: [],
      payment_method_array: [],
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
    };
  },
  watch: {
    element: {
      handler: function (newValue) {
        if (newValue) {
          this.element = newValue;
        }
      },
      deep: true,
    },
    element2: {
      handler: function (newValue) {
        if (newValue) {
          this.element2 = newValue;
        }
      },
      deep: true,
    },
    element3: {
      handler: function (newValue) {
        if (newValue) {
          this.element3 = newValue;
        }
      },
      deep: true,
    },
    element4: {
      handler: function (newValue) {
        if (newValue) {
          this.element4 = newValue;
        }
      },
      deep: true,
    },
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => ({ text: f.label, value: f.key }));
    },

    element() {
      var date = this.created_date_from ? this.created_date_from : null;
      var disabledDates = {
        to: new Date(date - 8640000),
        from: new Date(Date.now() + 8640000),
      };
      return disabledDates;
    },
    element2() {
      var date = this.created_date_to ? this.created_date_to : Date.now();
      var disabledDates = {
        from: new Date(date + 8640000),
      };
      return disabledDates;
    },
    element3() {
      var date = this.paid_date_from ? this.paid_date_from : Date.now();
      var disabledDates = {
        to: new Date(date - 8640000),
        from: new Date(Date.now() + 8640000),
      };
      return disabledDates;
    },
    element4() {
      var disabledDates = {
        from: new Date(this.paid_date_to + 8640000),
      };
      return disabledDates;
    },
  },
  beforeCreate() {
    const formData = new FormData();
    formData.append("search_param", "");
    formData.append("limit", "1000");
    formData.append("page", "1");
    formData.append("sort_by", "");
    formData.append("is_sort_asc", true);
    this.$store
      .dispatch("PaymentMethodModule/getPaymentMethods", formData)
      .then((response) => {
        this.payment_method_array = response.results;
        this.loading = false;
      })
      .catch((error) => {
        this.$swal({
          type: "error",
          title: "Oops...",
          text: error.response.data.message,
          showConfirmButton: false,
          timer: 1500,
        });
        this.loading = false;
      });
  },
  methods: {
    downloadCSV() {
      this.$swal({
        title: "Download CSV Report??",
        text: "Proses ini akan memakan waktu dan beban pada database",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ya!",
        cancelButtonText: "Tidak",
      }).then((result) => {
        if (result.value) {
          this.loadingCSV = true;
          const formData = new FormData();
          formData.append("search_param", "");
          formData.append("sort_by", "");
          formData.append("is_sort_asc", false);
          formData.append("ref_number", this.ref_number);
          formData.append("awb_number", this.awb_number);
          formData.append("amount_min", this.amount_min);
          formData.append("amount_max", this.amount_max);
          formData.append("transaction_status", this.trensaction_status);
          formData.append("payment_method", this.payment_method);
          formData.append("locker_order_type", this.locker_order_type);
          formData.append(
            "created_from",
            this.created_date_from
              ? moment(this.created_date_from).format("YYYY-MM-DD")
              : ""
          );
          formData.append(
            "created_to",
            this.created_date_to
              ? moment(this.created_date_to).format("YYYY-MM-DD")
              : ""
          );
          formData.append(
            "paid_from",
            this.paid_date_from
              ? moment(this.paid_date_from).format("YYYY-MM-DD")
              : ""
          );
          formData.append(
            "paid_to",
            this.paid_date_to
              ? moment(this.paid_date_to).format("YYYY-MM-DD")
              : ""
          );
          this.$store
            .dispatch("TransactionLogModule/getTransactionExport", formData)
            .then((response) => {
              this.CSV = response.data.data;
              setTimeout(() => {
                this.loadingCSV = false;
                this.$refs.DownloadCSV.$el.click();
              }, 1000);
            })
            .catch((error) => {
              this.loadingCSV = false;
            });
        } else {
        }
      });
    },
    ResetFilterData() {
      this.ref_number = "";
      this.awb_number = "";
      this.amount_min = "";
      this.amount_max = "";
      this.trensaction_status = "";
      this.payment_method = "";
      this.locker_order_type = "";
      this.created_date_from = new Date(Date.now()-8640000);
      this.created_date_to = new Date(Date.now());
      this.paid_date_from = "";
      this.paid_date_to = "";
      this.$refs.pxContent.refresh();
      this.filterShow = false;
    },
    FilterData() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$refs.pxContent.refresh();
          this.filterShow = false;
        } else {
          this.$swal({
            type: "error",
            title: "Oops...",
            text: "Invalid form input",
            showConfirmButton: false,
            timer: 1500,
          });
        }
      });
    },
    pxDate() {
      if (this.date_to < this.date_from) {
        this.$swal({
          title: "Tanggal tidak sesuai!",
          type: "error",
          showConfirmButton: false,
          timer: 1000,
        });
      } else {
        this.$refs.pxContent.refresh();
      }
    },
    resetCreatedDateFrom() {
      this.created_date_from = "";
    },
    resetCreatedDateTo() {
      this.created_date_to = "";
    },
    resetPaidDateFrom() {
      this.paid_date_from = "";
    },
    resetPaidDateTo() {
      this.paid_date_to = "";
    },
    customFormatter(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    getInfo(ctx, callback) {
      this.loading = true;
      const vm = this;
      const formData = new FormData();
      formData.append("search_param", ctx.filter);
      formData.append("limit", ctx.perPage);
      formData.append("page", ctx.currentPage);
      formData.append("sort_by", ctx.sortBy);
      formData.append("is_sort_asc", ctx.sortDesc);
      formData.append("ref_number", this.ref_number);
      formData.append("awb_number", this.awb_number);
      formData.append("amount_min", this.amount_min);
      formData.append("amount_max", this.amount_max);
      formData.append("transaction_status", this.trensaction_status);
      formData.append("payment_method", this.payment_method);
      formData.append("locker_order_type", this.locker_order_type);
      formData.append(
        "created_from",
        this.created_date_from
          ? moment(this.created_date_from).format("YYYY-MM-DD")
          : ""
      );
      formData.append(
        "created_to",
        this.created_date_to
          ? moment(this.created_date_to).format("YYYY-MM-DD")
          : ""
      );
      formData.append(
        "paid_from",
        this.paid_date_from
          ? moment(this.paid_date_from).format("YYYY-MM-DD")
          : ""
      );
      formData.append(
        "paid_to",
        this.paid_date_to ? moment(this.paid_date_to).format("YYYY-MM-DD") : ""
      );
      this.$store
        .dispatch("TransactionLogModule/getTransactionLogs", formData)
        .then((response) => {
          vm.totalRows = response.data.data.total_record;
          callback(response.data.data.results || []);
          this.loading = false;
          this.candidate = response.data.data;
        })
        .catch((error) => {
          this.loading = false;
          callback([]);
        });
      return null;
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      this.infoModal.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
};
</script>

<style>
</style>
